if (!customElements.get('julen-reveal')) {
  customElements.define('julen-reveal', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const slider = this.querySelector('input[type="range"]');
      if (!slider) return;
      const update = () => {
        const value = Number(slider.value);
        this.style.setProperty('--reveal', value + '%');
        this.style.setProperty('--identity-opacity', Math.max(0, Math.min(1, (80-value)/20)));
        slider.setAttribute('aria-valuetext', value + ' procent onthuld');
      };
      slider.addEventListener('input', update);
      update();
    }
  });
}
